<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="PN"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="ePub-SC">PART ONE</span></span></p>
<p class="PT"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="ePub-I">A House on a Winter Night</span></span></p>
<p class="page-break"> </p>
<p class="sp"> </p>
<p class="PEP" id="pt1epi"><span class="ePub-I">When an obscure data-management company launched what it called “the Affinities” a couple of years ago, almost no one paid attention. It was a quixotic idea that seemed to gain no traction: there was no ad campaign outside of a few media outlets in a few major cities, and not much press coverage even in those markets. But something surprising was happening under the radar … </span></p>
<p class="PEPL"><span class="ePub-I">Invited as a special guest to a local meeting, I arrived with limited expectations. What I would find, I suspected, was a group of perfectly ordinary people who had been convinced to pay annual dues for the privilege of flattering one another, a commercial conceit of which P. T. Barnum might have been proud. But there was a real energy in the gathering—social, sexual, intellectual—that took me by surprise. It made me wonder where all this was going, and I asked one young woman what she thought the members of her Affinity might be doing in twenty or thirty years.</span></p>
<p class="PEPL"><span class="ePub-I">She laughed at the question. “Writing our memoirs, I guess,” she said. “Or maybe signing our confessions.”</span></p>
<div class="PEPC-sp">
<p class="PEPC">—<span class="ePub-I">The Atlantic</span>, feature article, “Teleodynamics, Meir Klein, and the Rise of the Affinities”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?b1d34f12